import {Component, ViewChild} from '@angular/core';
import {Events, IonicPage, NavController, NavParams, Platform, Refresher} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {TeamServiceProvider} from "../../providers/team-service/team-service";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";
import {SearchServiceProvider} from "../../providers/search-service/search-service";
import {ShopPage} from "../shop/shop";
import {DiscoveryFeedMapPage} from "../discovery-feed-map/discovery-feed-map";
import { CoffeShopPage } from '../coffe-shop/coffe-shop';

@IonicPage()
@Component({
  selector: 'page-search-results',
  templateUrl: 'search-results.html',
})
export class SearchResultsPage {

  errors: {};
  loading: boolean;
  shops: any;
  searchTerm: string;
  searchError: string = '';
  latLng: any;
  viewTab:any="list";

  @ViewChild(Refresher) refresher: Refresher;

  constructor(
    public platform: Platform,
    public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    private http: HttpClient,
    private teamProvider: TeamServiceProvider,
    private apiErrorHandler: ApiErrorHandlerProvider,
    private searchProvider: SearchServiceProvider
  ) {
    this.searchTerm = navParams.get('searchTerm');
    this.shops = navParams.get('shops');
    this.latLng = navParams.get('latLng');
  }

  ionViewDidLoad() {

  }

  //@todo Currently the MapPage calls the teams API to reload the shops rather than just plotting these shops
  openShopsMap(shops) {
    this.navCtrl.push(DiscoveryFeedMapPage, {
      shops: shops,
      latLng: this.latLng,
      updateShopsOnMove: false
    });
  }

  openPage(event: any, shop: object) {
    this.navCtrl.push(ShopPage, {
      shop: shop
    });
  }

  search() {
    this.loading = true;
    this.shops = [];

    this.getShops().then(shops => {
      this.loading = false;
    })
  }

  getShops() {
    return new Promise((resolve) => {
      this.searchProvider.search(this.searchTerm).then((shops: any) => {
        if (shops) {
          shops.forEach((shop: any) => {
            shop.profile_data = null;
            if (shop.users) {
              shop.users.forEach((user: any) => {
                if (user.profile_data && typeof (user.profile_data) == "string") {
                  user.profile_data = JSON.parse(user.profile_data);
                  if (user.profile_data && user.profile_data.image_url && typeof (user.profile_data.image_url) == "string") {
                    user.profile_data.image_url = JSON.parse(user.profile_data.image_url);
                  }
                  shop.profile_data = user.profile_data;
                  return;
                } else {
                  shop.profile_data = user.profile_data;
                  return;
                }
              });
            }
          });
        }

        this.shops = shops;
        // shops.forEach(shop => {
        //   this.searchProvider.getShopQueueTime(shop).then(shopWithQueue => {
        //     shop.queue = shopWithQueue;
        //   })
        // });
        resolve(shops);
      }).catch(error => {
        this.searchError = error.error.errors.shop[0];
        this.loading = false;
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/search-results/search-results.ts